import bentoLogo from '../assets/BentoLogo.png';

export function BentoLogo({ className = "h-24 w-auto" }: { className?: string }) {
  return (
    <img
      src={bentoLogo}
      alt="Bento Logo"
      className={className}
    />
  );
}



